import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAttrs } from "vue";
// const databaseFormat = "YYYY-MM-DD";

// export default {
//   inheritAttrs: false,
// };

import { defineComponent, computed } from "vue";
const __default__ = defineComponent({
  name: "VZInput",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const attrs = useAttrs();
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };
  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps({ type: "password" }, _ctx.clonedAttrs, { class: "VZ_TABLE_INPUT" }), null, 16))
}
}

})